import React, { useState } from "react";
import "./ProblemsListView.css";

const ProblemsListView = ({ floors, problems, currentIndex, setCurrentIndex }) => {
  const [expandedFloors, setExpandedFloors] = useState({});
  const [expandedProblems, setExpandedProblems] = useState({});

  // Funkcja do przełączania rozwijania pięter
  const toggleFloor = (index) => {
    setExpandedFloors((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Funkcja do ustawiania currentIndex na wybrane piętro
  const handleFloorClick = (index) => {
    setCurrentIndex(index);
  };

  // Funkcja do przełączania rozwijania problemów w pokojach
  const toggleProblems = (roomId) => {
    setExpandedProblems((prev) => ({
      ...prev,
      [roomId]: !prev[roomId],
    }));
  };

  // Funkcja sprawdzająca, czy piętro ma problematyczne pokoje
  const hasProblems = (floor) => {
    if (floor && floor.rooms) {
      return floor.rooms.some((room) => problems[room.id]?.length > 0);
    }
    return false;
  };

  // Funkcja obliczająca liczbę problemów na piętrze
  const getFloorProblemCount = (floor) => {
    if (floor && floor.rooms) {
      return floor.rooms.reduce((sum, room) => sum + (problems[room.id]?.length || 0), 0);
    }
    return 0;
  };

  return (
    <div className="floors-view">
      {floors.map((floor, index) => (
        <div
          key={floor.id}
          className={`floor-item ${hasProblems(floor) ? "has-problems" : ""} ${currentIndex === index ? "selected" : ""}`}
        >
          <div className="floor-header">
            <span className="floor-toggle" onClick={() => toggleFloor(index)}>
              {expandedFloors[index] ? "[-]" : "[+]"} {floor.name} ({getFloorProblemCount(floor)})
            </span>
            <button
              className="floor-select-button"
              onClick={() => handleFloorClick(index)}
            >
              Show map
            </button>
          </div>
          {expandedFloors[index] && (
            <div className="floor-rooms">
              {floor.rooms.map((room) => (
                <div
                  key={room.id}
                  className={`room-item ${problems[room.id]?.length > 0 ? "has-problems" : ""}`}
                >
                  <div className="room-header">
                    <span>{room.name} {problems[room.id]?.length > 0 ? `(${problems[room.id].length})` : ""}</span>
                    {problems[room.id]?.length > 0 && (
                      <button
                        className="room-problems-toggle"
                        onClick={() => toggleProblems(room.id)}
                      >
                        {expandedProblems[room.id] ? "Hide problems" : "Show problems"}
                      </button>
                    )}
                  </div>
                  {expandedProblems[room.id] && (
                    <ul className="room-problems-list">
                      {problems[room.id].map((problem, idx) => (
                        <li key={idx} className="room-problem-item">
                          {problem.kind}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


export default ProblemsListView;


